module.exports = __webpack_public_path__ + "img/36_bohle.7dbdd2d2.jpeg";